import { useContext, useEffect, useState } from 'react';
import { UserService } from '../../services/user/userService';
import { PrivilegeContext } from '../../components/priviledge/PriviledgeProvider';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage users fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de usuarios.
----------------------------------------------------------------------------------------*/

const useUsers = (initialFilters = {}, withPermission = false) => {

    const { userCan } = useContext(PrivilegeContext);
    const [data, setData] = useState<any[]>([]);
    
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });

    const fetchUsers = async () => {
        if (withPermission && !userCan('get_users_for_select', 'user')) return;
        try {
            const service = new UserService();
            const response = await service.listUsersForSelect(filters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; lastName: string; }) => ({
                    value: data.id,
                    label: data.name + (data.lastName ? ` ${data.lastName}` : ''),
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching users:', error);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, [filters]);

    const getUsersList = () => {
        return data;
    };

    const getUserForSelectList = () => {
        return data;
    };

    return { fetchUsers, getUsersList, getUserForSelectList };
}

export default useUsers;